module.exports = __webpack_public_path__ + "img/260.91cdca1e.jpg";